<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="hero-section ptb-100" style="background:#00A39C">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                        <h1 class="text-white mb-0">Registro</h1>
                        <div class="custom-breadcrumb">
                            <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                                <li class="list-inline-item breadcrumb-item"><a href="#">Llena tus datos y realiza el pago para completar tu inscripción.</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="steps-header shadow">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-10">
                    <el-steps :active="step" finish-status="success" align-center>
                        <el-step title="Detalle del curso"></el-step>
                        <el-step title="Datos del alumno"></el-step>
                        <el-step title="Datos de facturación"></el-step>
                        <el-step title="Resumen"></el-step>
                    </el-steps>
                </div>
            </div>
        </div>
    </section>
    <section class="customer-review-section py-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-7">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                        <div v-if="step == 0" class="ep-setp-one">
                            <div class="form-group row mb-0">
                                <label class="col-sm-4 col-form-label text-left">Escuela seleccionada</label>
                                <div class="col-sm-6">
                                    <h3 class="mb-3">{{listDetails[0].title}}</h3>
                                </div>
                            </div>
                            <div class="form-group row mb-0">
                                <label class="col-sm-4 col-form-label text-left">Precio</label>
                                <div class="col-sm-6">
                                    <h2 class="text-primary">S/ {{listDetails[0].price}}</h2>
                                </div>
                            </div>
                            <div class="form-group row mb-0">
                                <label class="col-sm-4 col-form-label text-left">Horarios</label>

                                <div class="row">
                                  <el-form-item prop="getSchedule">
                                    <el-radio-group v-model="ruleForm.getSchedule">
                                        <div v-for="item in listDetails[0].scheduls" :key="item.idschedule" class="col-lg-12">
                                            <label class="option mb-2 p-2 pr-4 pt-4 pb-3">

                                                <span v-if="item.tagschedule>0" :class="'category position-absolute badge badge-pill badge-'+item.tagClass" >{{item.tagName}}</span>
                                                <span class="option-control">
                                                    <span class="radio">
                                                    <el-radio :label="item.idschedule"></el-radio>
                                                        <span></span>
                                                    </span>
                                                </span>
                                                <span class="option-label border-right w-100 mr-1">
                                                    <span class="option-head">
                                                        <span class="option-title mb-1">{{item.title}} (Inicia {{item.startdate |  moment('DD [de] MMMM')}}) </span>
                                                    </span>
                                                    <span class="option-body pt-0" v-html="item.schedule"></span>
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <div class="symbol symbol-circle symbol-success mx-2">
                                                        <img alt="Serpar" :src="'https://apv.serpar.gob.pe/assets/media/teachers/'+item.img">
                                                    </div>
                                                    <div class="d-flex flex-column text-left">
                                                        <span class="text-muted font-weight-bold">Docente</span>
                                                        <span class="text-success font-weight-bold" v-text="item.firstname + item.lastname"></span>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </el-radio-group>
                                  </el-form-item>
                                </div>

                                <!--<el-form-item prop="getSchedule">
                                    <el-radio-group v-model="ruleForm.getSchedule">
                                        <ul>
                                            <li class="mb-2" v-for="item in listDetails[0].scheduls" :key="item.idschedule">dfdf
                                                <el-radio :label="item.idschedule">{{item.schedule}}</el-radio>
                                            </li>
                                        </ul>
                                    </el-radio-group>
                                </el-form-item>-->

                            </div>

                        </div>
                        <div v-if="step == 1" class="ep-step-tree">
                            <div class="row">
                                <div class="col-sm-6">
                                    <el-form-item label="Documento" prop="tdocument">
                                        <el-select v-model="ruleForm.tdocument" placeholder="Selecciona">
                                            <el-option v-for="item in listDocuments" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="col-sm-6">
                                    <el-form-item label="N° Documento" prop="ndocument">
                                        <el-input v-model="ruleForm.ndocument" maxlength="13"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <el-form-item label="Nombres y apellidos completos" prop="firstname">
                                <el-input v-model="ruleForm.firstname" maxlength="50"></el-input>
                            </el-form-item>
                            <div class="row">
                                <div class="col-sm-6">
                                    <el-form-item label="Fecha de nacimiento" prop="fnac">
                                        <el-date-picker v-model="ruleForm.fnac" type="date" placeholder="seleccione" default-value="2000-01-01" format="dd/MM/yyyy">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div class="col-sm-6">
                                    <el-form-item label="Sexo" prop="sex">
                                        <el-select v-model="ruleForm.sex" placeholder="Selecciona">
                                            <el-option v-for="item in listSex" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <el-form-item label="Celular" prop="phone1">
                                        <el-input v-model="ruleForm.phone1" maxlength="9"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="col-sm-6">
                                    <el-form-item label="Teléfono fijo">
                                        <el-input v-model="ruleForm.phone2" maxlength="9"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-left">Dirección*</label>
                                <div class="col-sm-10">
                                    <el-form-item prop="address">
                                        <el-input v-model="ruleForm.address"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-left">Email*</label>
                                <div class="col-sm-10">
                                    <el-form-item prop="email">
                                        <el-input v-model="ruleForm.email" maxlength="100"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                        </div>

                        <div v-if="step == 2" class="ep-step-tree">
                            <el-form-item label="Selecciona el tipo de comprobante que deseas recibir" prop="voucher">
                                <el-radio-group v-model="ruleForm.voucher" @change="changeVoucher">
                                    <el-radio v-for="item in listVoucher" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <div v-if="ruleForm.voucher == 'B'">
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">DNI/N° Documento*</label>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cDniRuc">
                                            <el-input v-model="ruleForm.cDniRuc" maxlength="8"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left pr-2">Nombres y apellidos*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cNameRazon">
                                            <el-input v-model="ruleForm.cNameRazon" maxlength="100"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Teléfono/Celular*</label>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cPhone">
                                            <el-input v-model="ruleForm.cPhone" maxlength="9"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Correo electrónico*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cEmail">
                                            <el-input v-model="ruleForm.cEmail" maxlength="100"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">RUC*</label>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cDniRuc">
                                            <el-input v-model="ruleForm.cDniRuc" maxlength="11"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Razón Social*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cNameRazon">
                                            <el-input v-model="ruleForm.cNameRazon" maxlength="100"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Dirección*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cAddress">
                                            <el-input v-model="ruleForm.cAddress" maxlength="300"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Teléfono/Celular*</label>
                                    <div class="col-sm-6">
                                        <el-form-item prop="cPhone">
                                            <el-input v-model="ruleForm.cPhone" maxlength="9"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label text-left">Correo electrónico*</label>
                                    <div class="col-sm-8">
                                        <el-form-item prop="cEmail">
                                            <el-input v-model="ruleForm.cEmail" maxlength="100"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="step >= 3" class="ep-step-five">
                            <el-collapse v-model="activeName" accordion>
                                <el-collapse-item title="Detalle del curso" name="1">
                                    <div class="row">
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Escuela: </label>
                                        <div class="col-sm-9 col-form-label">{{listDetails[0].title}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Precio: </label>
                                        <div class="col-sm-9 col-form-label">S/ {{listDetails[0].price}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Horario: </label>
                                        <div class="col-sm-9 col-form-label" v-html="detailScheduls[0].schedule"></div>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item title="Datos del alumno" name="2">
                                    <div class="row">
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">{{detailDocs[0].name}}</label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.ndocument}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Alumno: </label>
                                        <div class="col-sm-9 col-form-label text-uppercase">{{ruleForm.firstname}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">F. Nacimiento: </label>
                                        <div class="col-sm-8 col-form-label">{{ruleForm.birthday | moment('DD/MM/YYYY')}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Sexo: </label>
                                        <div class="col-sm-9 col-form-label text-uppercase">{{(ruleForm.sex == 'M')?'Masculino':((ruleForm.sex == 'F')?'Femenino':'Sin especificar')}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Celular: </label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.phone1}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Dirección: </label>
                                        <div class="col-sm-9 col-form-label text-uppercase">{{ruleForm.address}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Email: </label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.email}}</div>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item title="Datos de facturación" name="3">
                                    <div class="row">
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Comprobante: </label>
                                        <div class="col-sm-9 col-form-label text-uppercase">{{(ruleForm.voucher == 'B')?'Boleta':'Factura'}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">{{(ruleForm.voucher == 'B')?'DNI':'RUC'}}: </label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.cDniRuc}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">{{(ruleForm.voucher == 'B')?'Nombre':'Razón Social'}}: </label>
                                        <div class="col-sm-9 col-form-label text-uppercase">{{ruleForm.cNameRazon}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Celular: </label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.cPhone}}</div>
                                        <label class="col-sm-3 text-sm-left col-form-label text-md-right">Email: </label>
                                        <div class="col-sm-9 col-form-label">{{ruleForm.cEmail}}</div>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>

                            <el-form-item prop="terms" required>
                                <el-checkbox v-model="ruleForm.terms" name="terms">He leído y acepto los
                                    <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
                            </el-form-item>
                            <el-form-item prop="terms2" :class="'terms2'" required>
                                <el-checkbox v-model="ruleForm.terms2" name="terms2">Acepto que al realizar la matrícula en el curso y horario seleccionado<br> no habrán posteriores cambios ni devoluciones. <br>Serpar no se hace responsable de equivocaciones o cierre del curso por casos de fuerza<br> mayor como fenómenos sociales o naturales de toda índole.</el-checkbox>
                            </el-form-item>
                        </div>

                    </el-form>
                    <button class="btn outline-btn mb-3 mt-3" @click.prevent="epBack('ruleForm')">Anterior</button>
                    <button class="btn outline-btn my-5" @click.prevent="submitForm('ruleForm')">{{(step == 3)? 'Ir a pagar':'Siguiente'}}</button>
                </div>
            </div>
        </div>
    </section>

</div>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        var checkAge = (rule, value, callback) => {
            if (!value) {
                if (!this.ruleForm.getSchedule)
                    return callback(new Error(`Aún no ha seleccionado ningun horario.`));
                else if (this.listDetails[0].scheduls.length == 0)
                    return callback(new Error(`Lo sentimos, no contamos con horarios disponibles.`));
                else
                    return callback(new Error(`Tiene que seleccionar un horario.`));
            } else {
                callback();
            }
        };
        return {
            slug: '',
            step: 0,
            activeName: '1',
            totalSteps: 4,
            listDetails: [],
            detailDocs: [],
            detailSex: [],
            detailScheduls: [],
            listDocuments: [{
                    id: '01',
                    name: 'DNI'
                },
                {
                    id: '04',
                    name: 'Carnet de Extranjeria'
                },
                {
                    id: '07',
                    name: 'Pasaporte'
                },
            ],
            listSex: [{
                    id: 'M',
                    name: 'Masculino'
                },
                {
                    id: 'F',
                    name: 'Femenino'
                },
                {
                    id: 'S',
                    name: 'Sin especificar'
                },
            ],
            listVoucher: [{
                    id: 'B',
                    name: 'Boleta'
                },
                {
                    id: 'F',
                    name: 'Factura'
                },
            ],
            ruleForm: {
                getSports: '',
                getSchedule: '',
                tdocument: '',
                ndocument: '',
                firstname: '',
                fnac: '',
                birthday: '',
                sex: '',
                phone1: '',
                phone2: '',
                address: '',
                email: '',
                voucher: 'B',
                cDniRuc: '',
                cNameRazon: '',
                cAddress: '',
                cPhone: '',
                cEmail: '',
                terms: false,
                terms2: false

            },
            rules: {
                getSchedule: [{
                    validator: checkAge,
                    trigger: 'change'
                }],
                tdocument: [{
                    required: true,
                    message: 'Selecciona tipo de documento',
                    trigger: 'change'
                }],
                ndocument: [{
                    required: true,
                    message: 'Falta número de documento',
                    trigger: 'blur'
                }],
                firstname: [{
                    required: true,
                    message: 'Falta nombres completos',
                    trigger: 'blur'
                }],
                fnac: [{
                    type: 'date',
                    required: true,
                    message: 'Ingrese fecha de nacimiento',
                    trigger: 'change'
                }],
                sex: [{
                    required: true,
                    message: 'Selecciona sexo',
                    trigger: 'change'
                }],
                phone1: [{
                    required: true,
                    message: 'Falta celular',
                    trigger: 'blur'
                }],
                address: [{
                    required: true,
                    message: 'Falta ingresar dirección',
                    trigger: 'blur'
                }],
                email: [{
                    required: true,
                    message: 'Falta ingresar correo electrónico',
                    trigger: ['blur', 'change']
                }, {
                    type: 'email',
                    message: 'Ingrese dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }],
                cDniRuc: [{
                    required: true,
                    message: 'Falta ingresar este campo',
                    trigger: 'blur'
                }],
                cNameRazon: [{
                    required: true,
                    message: 'Falta ingresar este campo',
                    trigger: 'blur'
                }],
                cPhone: [{
                    required: true,
                    message: 'Falta ingresar teléfono',
                    trigger: 'blur'
                }],
                cAddress: [{
                    required: true,
                    message: 'Falta ingresar este campo',
                    trigger: 'blur'
                }],
                cEmail: [{
                    required: true,
                    message: 'Falta ingresar correo electrónico',
                    trigger: ['blur', 'change']
                }, {
                    type: 'email',
                    message: 'Ingrese dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }],
                terms: [{
                    required: true,
                    message: 'Falta seleccionar los terminos',
                    trigger: ['blur', 'change']
                }],
                terms2: [{
                    required: true,
                    message: 'Falta seleccionar los terminos',
                    trigger: ['blur', 'change']
                }]

            }
        }
    },
    methods: {
        getDetailsCourse() {
            this.fullscreenLoading = true;
            var formdata = new FormData();
            formdata.append('slug', this.slug);
            axios.post(`${process.env.API1}/virtual/details`, formdata).then(response => {
                this.listDetails = response.data;
                this.fullscreenLoading = false;
                if(this.listDetails[0].shopping == 1){
                    this.$router.push({
                        path: `/not-available`
                    })
                }
            });
        },
        epBack(formName) {
            if (this.step != 0) {
                this.step--;
                this.ruleForm.terms = false;
                this.textePresencial = 'Siguiente';
            }

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.step < this.totalSteps) this.step++;
                    if (this.step == this.totalSteps) {
                        this.step--;
                    }

                    //search schedule
                    if (this.step == 2) {
                        //alert('enviano');
                        this.detailScheduls = this.listDetails[0].scheduls.filter(schedul => schedul.idschedule.includes(this.ruleForm.getSchedule));
                        this.detailDocs = this.listDocuments.filter(doc => doc.id.includes(this.ruleForm.tdocument));
                        this.detailSex = this.listSex.filter(sex => sex.id.includes(this.ruleForm.sex));
                        this.ruleForm.birthday = moment(this.ruleForm.fnac).format("YYYY-MM-DD");
                    }
                    if (this.ruleForm.terms == true && this.ruleForm.terms2 == true) {
                        this.fullscreenLoading = true;
                        this.ruleForm.getSports = this.listDetails[0].idproduct;
                        this.ruleForm.nameProduct = this.listDetails[0].title;
                        this.ruleForm.priceProduct = this.listDetails[0].price;
                        this.ruleForm.nameSchedule = this.detailScheduls[0].schedule;
                        let formDatas = this.formDatas(this.ruleForm);
                        axios.post(`${process.env.API1}/virtual/register`, formDatas).then(response => {
                            this.fullscreenLoading = false;
                            if (response.data.status == 'success') {
                                window.location.href = response.data.url
                            } else {
                                this.$alert(response.data.message, 'Lo sentimos!', {
                                    confirmButtonText: 'Entendido',
                                    type: 'error',
                                    center: true,
                                    callback: action => {}
                                });
                            }
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }

            });
        },
        formDatas(obj) {
            let formData = new FormData();
            for (var key in obj) {
                formData.append(key, obj[key]);
            }
            return formData;
        },
        changeVoucher() {
            this.ruleForm.cDniRuc = '';
            this.ruleForm.cNameRazon = '';
            this.ruleForm.cPhone = '';
            this.ruleForm.cEmail = '';
        },
    },
    created() {
        this.slug = this.$route.params.slug;
        this.getDetailsCourse();
    }
}
</script>

<style>
.el-step__title.is-process,
.el-step__head.is-process {
    color: #1A4A84 !important;
}

.el-step__head.is-process {
    border-color: #1A4A84
}

.steps-header {
    padding: 20px;
    background: #fafafa;
}

.el-select {
    width: 100%;
}

.el-collapse-item__header {
    font-weight: 700;
    font-size: 1rem;
}

.el-collapse-item__header.is-active {
    color: #00a39c;
}
.option .el-radio__label{display: none !important; color:#1A4A84 !important;}
.terms2 .el-checkbox__input{top:5px; float:left;}

</style>



// WEBPACK FOOTER //
// src/components/pages/evirtual/register.vue